<template>
  <div class="wrapper">
    <header></header>
    <section>
      <div class="qrcode-img-wrp">
        <VueQrcode class="qrcode" :value="data.qrcodeImg" :options="{size:500}"></VueQrcode>
      </div>
      <div class="modal-money-wrp">
        <p>发票金额</p>
        <p style="color: #333">{{convertNumber(data.money)}}</p>
      </div>
      <div class="modal-remark-wrp">
        <p class="title">发票备注</p>
        <p style="color: #333">{{data.remark || '--'}}</p>
      </div>
      <div class="modal-remark-wrp" v-if="data.orderCode">
        <p class="title">订单编号</p>
        <p style="color: #333">{{data.orderCode}}</p>
      </div>
      <div class="modal-remark-wrp" v-else-if="data.settlementNo">
        <p class="title">结算单号</p>
        <p style="color: #333">{{data.settlementNo}}</p>
      </div>
      <div class="modal-remark-wrp" v-else>
        <p class="title">订单编号</p>
        <p style="color: #333">--</p>
      </div>
      <div class="modal-remark-wrp">
        <p class="title">单据附注</p>
        <p style="color: #333">{{data.attachAnnotation || '--'}}</p>
      </div>
      <div class="modal-tips">
        <div class="modal-tips-left iconfont">
          &#xe6e2;
        </div>
        <div>
          <div>* 二维码有效期至{{ prescription || '' }}</div>
          <div>* 电子发票默认推送至客户指定邮箱</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VueQrcode from '@xkeshi/vue-qrcode'
import { ConvertNumber, getQuery, aesDoEncrypt } from '@utils/basicUtil'
import { businessRequest } from '@services'
import { Notify, Toast } from 'vant'
export default {
  components: {
    VueQrcode,
    [Toast.name]: Toast
  },
  props: {},
  data () {
    return {
      data: {
        qrcodeImg: '',
        money: 0,
        remark: ''
      },
      prescription: '15'
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.getOrderInfo()
  },
  activated () {},
  updated () {},
  methods: {
    convertNumber (data) {
      return ConvertNumber(data)
    },
    async getOrderInfo () {
      Toast.loading({
        message: '加载中...',
        duration: 0,
        forbidClick: true
      })
      let { id, prescription, infoId } = getQuery()
      try {
        this.prescription = JSON.parse(prescription) || ''
      } catch (error) {
        this.prescription = ''
        Toast.clear({
          clearAll: true
        })
      }
      const params = {
        settlementId: id,
        id: infoId
      }
      const data = await businessRequest.qrcode.getOrderInfo(params)
      if (data.success) {
        const key = aesDoEncrypt({ ...params, updateTime: data.result.updateTime })
        this.data.qrcodeImg = `http://${window.location.host}/order?key=${key}`
        this.data.money = data.result.amountWithTax
        this.data.remark = data.result.remark
        this.data.attachAnnotation = data.result.notes
        this.data.settlementNo = data.result.settlementNo
        this.data.orderCode = data.result.externalDocumentNo
      } else {
        Notify({ type: 'danger', message: data.result.message })
      }
      Toast.clear({
        clearAll: true
      })
    }
  }
}
</script>
<style lang="less" scoped src="./style.less"/>
